export default "__VITE_ASSET__CAdvDFc2__"